import { render, staticRenderFns } from "./quotationDetail.vue?vue&type=template&id=06158b3c&scoped=true"
import script from "./quotationDetail.vue?vue&type=script&lang=js"
export * from "./quotationDetail.vue?vue&type=script&lang=js"
import style0 from "./quotationDetail.vue?vue&type=style&index=0&id=06158b3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06158b3c",
  null
  
)

export default component.exports